module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_302946.6d9b76ca.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_302946.pdf
// module id = 811
// module chunks = 0